export const fonts = {
  editorialNew: "EditorialNew-Regular",
  gtFlexaMono: "GT-Flexa-Mono-Regular",
};
